import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../../../helpers/request';

const getDocumentVisibility = async () => {
  return await request.get(
    `/Docs/visibility`,
    null,
    'Произошла ошибка при загрузке типов видимости документа'
  );
};

export const useDocumentVisibilityQuery = (options = {}) => {
  return useQuery(
    queryKeys.documentVisibility(),
    () => getDocumentVisibility(),
    options
  );
};

export default useDocumentVisibilityQuery;
